<template>
  <v-flex xs6 md3> 
    <v-card class="e-cardDeshabilitada e-border--radius elevation-0 d-flex align-center " color="transparent">
      <v-card-text :class="practica ? 'px-5' : 'pa-2'">
        <img src="../../assets/images/unit/lock.svg" height="60" class="mb-2">
        <h4 class="e-subTitle grey-light--text text-xs-center mb-2">{{ title }}</h4>
        <p class="e-description-regular mb-0 grey-light--text">{{ descripcion }}</p>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: {
    router: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    descripcion: {
      type: String,
      default: ''
    },
    practica: {
      type: Boolean,
      default: false
    }
  }
}
</script>